import { Card, useWindowWidth } from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';

import { MOBILE_WIDTH } from '@/constants';

import { TLogo } from '../../types';

import { LogosDetail } from './components';

type LogosDetailsCardProps = {
  logos: TLogo;
  isCollapsed: boolean;
  onCollapse: () => void;
  onUpdate: (logos: TLogo) => void;
};

export function LogosDetailCard({
  isCollapsed,
  logos,
  onCollapse,
  onUpdate,
}: LogosDetailsCardProps) {
  const { width } = useWindowWidth();
  const isMobile = width < MOBILE_WIDTH;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card
      className="w-full"
      title={logos.name}
      isAccordion={isMobile}
      isCollapsable={!isMobile}
      isOpen={isOpen}
      collapseDirection="right"
      lineSeparator={true}
      isCollapsed={isCollapsed && !isMobile}
      onCollapse={onCollapse}
      onOpen={() => setIsOpen(!isOpen)}
      classes={{
        header: clsx(!isMobile && 'py-3'),
      }}
    >
      <div className="body flex flex-col gap-size-12 self-stretch">
        <LogosDetail logos={logos} onUpdate={onUpdate} />
      </div>
    </Card>
  );
}
